import React from 'react';
import { useSelector } from 'react-redux';
import { ResultStage } from 'api/StudentLoanApi';
import FormNavigation from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import Button from 'components/Button';
import { ButtonType } from 'components/Button/Button';
import StudentLoanLoaderWrapper from 'components/StudentLoanForgiveness/LoaderWrapper';
import { StepList } from 'components/StudentLoanForgiveness/Common/ResultBlocks';
import { getStepCopy } from 'components/StudentLoanForgiveness/studentLoanCopy';
import { STUDENT_AID_URL } from 'components/StudentLoanForgiveness/studentLoanFormat';
import { FlowComponentType } from 'routes/types';
import { getStudentLoanData } from 'selectors/getStudentLoanData';

import commonStyles from 'components/StudentLoanForgiveness/Common/Common.module.scss';

const Steps = ({ navigationInfo, handleNext }: FlowComponentType) => {
  const { result } = useSelector(getStudentLoanData);

  const steps = result && result.stage !== ResultStage.NoFederalLoans ? result.steps : [];
  const isPslfRecommended = result?.stage === ResultStage.Plan && result.recommended.pslf;

  return (
    <StudentLoanLoaderWrapper>
      <>
        <FormNavigation {...navigationInfo} />
        <FormContainer
          title="Steps to enroll"
          subtitle="All of this happens on studentaid.gov, free of charge. You never need to pay anyone to enroll."
        >
          <StepList steps={steps.map((step) => getStepCopy(step, { isPslfRecommended }))} />

          <div className={commonStyles.buttons}>
            <Button type={ButtonType.Secondary} onClick={() => window.open(STUDENT_AID_URL, '_blank', 'noopener')}>
              Open studentaid.gov
            </Button>
            <Button onClick={() => handleNext()}>Explore more savings</Button>
          </div>
        </FormContainer>
      </>
    </StudentLoanLoaderWrapper>
  );
};

export default Steps;
